import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  q: 'How much does air conditioning installation cost in Perth?',
  a: 'Installation in Perth ranges from A$2,500 for a single split system up to A$20,000 for a complete ducted reverse cycle system. Commercial installs sit between A$5,000 and A$80,000. We provide free on-site quotes with fixed pricing in writing before any work starts.'
}, {
  q: 'Do you service my suburb?',
  a: 'Yes. We install across all Perth metropolitan suburbs from our Balcatta workshop. Karrinyup, Subiaco, Hillarys, Joondalup, Mount Lawley, Sorrento, Duncraig and surrounding areas. Outside Perth metro? Call us, we travel for ducted jobs.'
}, {
  q: 'Which brand is best for Perth conditions?',
  a: 'Mitsubishi Electric, Daikin and Rinnai HRV are the most reliable brands for Perth conditions. We are a Mitsubishi Electric Diamond Dealer and install all three brands, recommending honestly based on your home.'
}, {
  q: 'How long does installation take?',
  a: 'Most split system installations are completed in a single day. Multi-head split installs take 1 to 2 days. Ducted reverse cycle installations typically take 2 to 3 days depending on home size and zone count.'
}, {
  q: 'Do you offer a warranty?',
  a: 'Yes. Lifetime workmanship guarantee on every install. If anything we installed fails because of our workmanship, we come back free. Plus full manufacturer warranty (5 to 10 years depending on brand) on all major brand units.'
}, {
  q: 'Can I get finance?',
  a: "Yes. Interest-free finance through Brighte and humm on jobs over A$5,000. Most ducted installs qualify. We'll walk you through what works at the quote visit."
}, {
  q: 'Do you remove the old unit?',
  a: 'Yes. Removal and responsible disposal of the existing system is included in every quote. We take it away the day of install.'
}, {
  q: 'How quickly can you install?',
  a: 'Replacement timing depends on stock and your availability. New install dates are confirmed at your on site quote, and Mike will give you a realistic date in writing.'
}];
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border-b border-stone-200 last:border-0" data-id="element-119">
      <button onClick={onClick} aria-expanded={isOpen} className="w-full flex items-start justify-between gap-6 py-6 text-left group" data-id="element-120">
        <span className="font-display text-lg lg:text-xl font-extrabold text-ink-900 tracking-tight leading-snug group-hover:text-brand transition-colors" data-id="element-121">
          {question}
        </span>
        <span className={`flex-shrink-0 w-10 h-10 rounded-full border border-stone-300 flex items-center justify-center transition-all ${isOpen ? 'bg-brand border-brand text-white rotate-45' : 'text-ink-900 group-hover:border-brand'}`} data-id="element-122">
          <Plus size={18} strokeWidth={2.5} data-id="element-123" />
        </span>
      </button>
      <AnimatePresence initial={false} data-id="element-124">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.04, 0.62, 0.23, 0.98]
      }} className="overflow-hidden" data-id="element-125">
            <div className="pb-7 pr-12 text-base leading-relaxed text-stone-600 max-w-3xl" data-id="element-126">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-20 md:py-28 scroll-mt-24" data-id="element-127">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="grid lg:grid-cols-12 gap-12" data-id="element-129">
          <div className="lg:col-span-4" data-id="element-130">
            <div className="kicker mb-3" data-id="element-131">Honest answers</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink-900 tracking-tight leading-tight mb-5" data-id="element-132">
              Questions you'd ask if we were at your table.
            </h2>
            <p className="text-base text-stone-600 leading-relaxed" data-id="element-133">
              Something not covered? Call Mike on{' '}
              <a href="tel:+61864043888" className="text-brand font-bold hover:underline tabular-nums" data-id="element-134">
                08 6404 3888
              </a>
              . He'd rather answer a real question than dodge it.
            </p>
          </div>
          <div className="lg:col-span-8" data-id="element-135">
            <div className="bg-white rounded-2xl px-6 lg:px-10 py-2 border border-stone-200 shadow-sm" data-id="element-136">
              {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-137" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}